import {projects} from './Projects.reducer'

export * from './Projects.action'
export * from './Projects.selectors'

export const projectsReducer = projects
